'use strict';

angular.module('youth').directive('msNotificationPopup', [function () {
  return {
    templateUrl: 'youth/templates/notification-popup.html',
    restrict: 'E',
    scope: {},
    controllerAs: 'vm',
    controller: 'NotificationPopupCtrl'
  };
}]).controller('NotificationPopupCtrl', ['notificationSvc', '$state', '$q', '$cookies', '$interval', '$rootScope', function (notificationSvc, $state, $q, $cookies, $interval, $rootScope) {
  var vm = this;
  var _currentNotifications = [];
  var socket = null;

  vm.notificationsVisible = false;

  _loadNotifications();

  // init websocket for notification events
  _initNotificationWebsocket();

  // set up the callback to refresh the notifications
  notificationSvc.registerRefreshCallback(_loadNotifications);

  function _initNotificationWebsocket() {
    var hasWebsocketFeature = window.MYSTRENGTH.config.platforms.web.features.websockets === true;

    if (!hasWebsocketFeature) {
      $interval(_loadNotifications, 30000, 0, false);
      return;
    }

    var urlPrefixRegex = new RegExp('^http(s?)', 'gm');
    var isHttps = new RegExp('^https:').test(window.MYSTRENGTH.API_URL);
    var websocketBaseUrl = window.MYSTRENGTH.API_URL.replace(urlPrefixRegex, isHttps ? 'wss' : 'ws');

    socket = new WebSocket(websocketBaseUrl + '/notification/session');

    // Authenticate using token on open
    socket.addEventListener('open', function () {
      socket.send(JSON.stringify({
        token: $cookies.get('token')
      }));
    });

    // Update notification on message
    socket.addEventListener('message', function (event) {
      var data = JSON.parse(event.data);

      _currentNotifications.push(data);
      $rootScope.$apply();
    });
  }

  /**
   * Will cause notification popup to toggle open or closed. When closing it will
   * set all notifications in list to be changed to SEEN status.
   */
  vm.toggleNotifications = function () {
    if (vm.notificationsVisible) {
      // Popup is open and about to close
      var _toChange = _.filter(_currentNotifications, function (n) {
        return n.status === 'NEW';
      });
      if (_toChange.length > 0) {
        notificationSvc.changeNotificationStatus(_toChange, 'SEEN').then(function () {
          angular.forEach(_toChange, function (n) {
            n.status = 'SEEN';
          });
        });
      }
    }
    vm.notificationsVisible = !vm.notificationsVisible;
  };

  vm.closeNotifications = function () {
    if (vm.notificationsVisible) {
      // Popup is open and about to close
      var _toChange = _.filter(_currentNotifications, function (n) {
        return n.status === 'NEW';
      });
      if (_toChange.length > 0) {
        notificationSvc.changeNotificationStatus(_toChange, 'SEEN').then(function () {
          angular.forEach(_toChange, function (n) {
            n.status = 'SEEN';
          });
        });
      }
    }
    vm.notificationsVisible = false;
  };

  $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
    vm.closeNotifications();
    // If you aren't routing to a specific reply, check for notifications.
    // There was a timing issue when marking a notification as READ and requesting new ones.
    if (!toParams.replyId) {
      _loadNotifications();
    }
  });

  /**
   * @returns {Array} Return the currently loaded notifications.
   */
  vm.getNotifications = function () {
    return _currentNotifications;
  };

  /**
   * When clicking on a notification in the popup, this function will be called to change
   * notification status to READ and then toggle the popup closed. This will also cause a
   * navigation event to the discussion page containing the comment.
   * @param notification
   */
  vm.navigateComment = function (notification) {
    notificationSvc.changeNotificationStatus([notification], 'READ').then(function () {
      // Remove newly updated notification from notifications list to prevent status overwrite below.
      _currentNotifications.splice(_.indexOf(_currentNotifications, function (n) {
        return n.uuid === notification.uuid;
      }), 1);
      // Close notification popup.
      vm.closeNotifications();

      if (notification.type === 'ACTIVITY_COMMENT' || notification.type === 'ACTIVITY_FAVORITE') {
        if (notification.properties.parentId !== 'null') {
          // This is a reply on a discussion comment
          $state.go('community.discussion.detail', {
            'commentId': notification.properties.parentId,
            'replyId': notification.properties.commentId,
            'activity': notification.properties.topic
          });
        } else {
          // This is a reply on a discussion
          $state.go('community.discussion.topic', {
            'replyId': notification.properties.commentId,
            'activity': notification.properties.topic
          });
        }
      }
      if (notification.type === 'ASSESSMENT') {
        $state.go('assessment');
      }
    });
  };

  /**
   * @returns {boolean} There are currentlwebsocketsy NEW or SEEN notifications available to the view
   */
  vm.notificationsAvailable = function () {
    return _currentNotifications.length > 0;
  };

  /**
   * @returns {boolean} There are currently NEW notifications available to the view.
   */
  vm.newNotificationsAvailable = function () {
    return _.filter(_currentNotifications, function (n) {
      return n.status === 'NEW';
    }).length > 0;
  };

  /**
   * This will cause all notifications currently available to the view to be updated to status READ.
   */
  vm.markAllNotificationsRead = function () {
    vm.notificationsVisible = false;
    notificationSvc.changeNotificationStatus(_currentNotifications, 'READ').then(function () {
      _currentNotifications = [];
    });
  };

  function _loadNotifications() {
    // Only load if the notification popup is closed
    if (!vm.notificationsVisible) {
      $q.all([notificationSvc.getNotificationsByStatus('NEW'), notificationSvc.getNotificationsByStatus('SEEN')]).then(function (resp) {
        var _notifications = resp[0];
        // Merge the two promise arrays together
        Array.prototype.push.apply(_notifications, resp[1]);
        // Sort notification list by created on date
        _currentNotifications = _notifications;
      });
    }
  }
}]);